/**
 * Completes full-variant hydration for products over Shopify's 250-variant cap:
 * - patches product.js fetch responses for the theme
 * - remounts ProductWiz if it already rendered with truncated data
 */
(function () {
  'use strict';

  var cfg = window.__wwFullVariants;
  if (!cfg || !cfg.handle || !cfg.enabled) return;

  // Shared with the inline snippet so merge + media resolution stay identical.
  function applyToAjaxProduct(product, variants) {
    return cfg.mergeIntoProduct(product, variants);
  }

  function isProductJsUrl(url) {
    if (!url) return false;
    try {
      var path = new URL(url, window.location.origin).pathname;
      return path === '/products/' + cfg.handle + '.js' || path.endsWith('/products/' + cfg.handle + '.js');
    } catch (e) {
      return String(url).indexOf('/products/' + cfg.handle + '.js') !== -1;
    }
  }

  function patchFetch(variantsPromise) {
    if (window.fetch && window.fetch.__wwFullVariantsPatched) return;
    var originalFetch = window.fetch.bind(window);

    function patchedFetch(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var request = originalFetch(input, init);
      if (!isProductJsUrl(url)) return request;

      return Promise.all([request, variantsPromise]).then(function (results) {
        var response = results[0];
        var variants = results[1];
        if (!response.ok || !variants || !variants.length) return response;
        return response
          .clone()
          .json()
          .then(function (data) {
            applyToAjaxProduct(data, variants);
            return new Response(JSON.stringify(data), {
              status: response.status,
              statusText: response.statusText,
              headers: { 'Content-Type': 'application/json' }
            });
          })
          .catch(function () {
            return response;
          });
      });
    }

    patchedFetch.__wwFullVariantsPatched = true;
    window.fetch = patchedFetch;
  }

  function remountProductWiz() {
    var root = document.querySelector('.rio-options, .rio-options-phantom');
    if (!root) return;

    var opts = window.__productWizRioOptions;
    if (!opts || typeof opts.queueRender !== 'function') return;

    // Clear the existing ProductWiz tree, then ask it to render again with full variants.
    try {
      root.innerHTML = '';
      opts.queueRender(root, opts);
    } catch (e) {
      console.warn('[ww-full-variants] ProductWiz remount failed', e);
    }
  }

  function refreshThemeSelectors() {
    document.querySelectorAll('product-variants').forEach(function (el) {
      try {
        if (typeof el._updateDisableSelectors === 'function') {
          el._updateDisableSelectors();
        }
      } catch (e) {}
    });
  }

  var enrichPromise = cfg.promise || Promise.resolve([]);
  patchFetch(enrichPromise);

  enrichPromise
    .then(function (variants) {
      if (typeof cfg.applyVariants === 'function') {
        cfg.applyVariants(variants || []);
      }
      // If ProductWiz already painted with truncated data, rebuild it.
      remountProductWiz();
      refreshThemeSelectors();
    })
    .catch(function (err) {
      console.warn('[ww-full-variants]', err);
    });
})();
